/* Favoritos. Se guardan en el navegador de cada persona, sin app de terceros
   y sin cuenta. Si manana se conecta una base de datos, esta misma lista es
   la que se sube. */
(function () {
  var LLAVE = 'tlr-favoritos';

  function leer() {
    try { return JSON.parse(localStorage.getItem(LLAVE) || '[]'); } catch (e) { return []; }
  }
  function guardar(lista) {
    try { localStorage.setItem(LLAVE, JSON.stringify(lista)); } catch (e) {}
    pintarContador(lista.length);
    document.dispatchEvent(new CustomEvent('tlr:favoritos', { detail: lista }));
  }
  function pintarContador(n) {
    document.querySelectorAll('[data-wish-n]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-off', n === 0);
    });
  }

  function pintarBoton(btn) {
    var handle = btn.getAttribute('data-wish');
    var dentro = leer().indexOf(handle) !== -1;
    btn.setAttribute('aria-pressed', dentro ? 'true' : 'false');
    var txt = btn.querySelector('[data-wish-txt]');
    if (txt) txt.textContent = dentro ? 'Guardado en favoritos' : 'Guardar en favoritos';
  }

  function alternar(handle) {
    var lista = leer();
    var i = lista.indexOf(handle);
    if (i === -1) { lista.push(handle); } else { lista.splice(i, 1); }
    guardar(lista);
    return lista.indexOf(handle) !== -1;
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-wish]');
    if (!btn) return;
    ev.preventDefault();
    alternar(btn.getAttribute('data-wish'));
    document.querySelectorAll('[data-wish]').forEach(pintarBoton);
  });

  function arranque() {
    var lista = leer();
    pintarContador(lista.length);
    document.querySelectorAll('[data-wish]').forEach(pintarBoton);

    var caja = document.querySelector('[data-wish-lista]');
    if (!caja) return;
    var vacio = document.querySelector('[data-wish-vacio]');
    var tarjetas = caja.querySelectorAll('[data-wish-item]');
    var vistos = 0;
    tarjetas.forEach(function (el) {
      var dentro = lista.indexOf(el.getAttribute('data-wish-item')) !== -1;
      el.hidden = !dentro;
      if (dentro) vistos++;
    });
    if (vacio) vacio.hidden = vistos > 0;
  }

  document.addEventListener('tlr:favoritos', arranque);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranque);
  } else {
    arranque();
  }
})();
